($ => {
	let formValidator;
	let locationsUtils;
	
	
	function init() {
		formValidator = Fw.component.models().form;
		locationsUtils = Fw.component.models().locationsUtils;
		
		var containerId="0";
		const gid = $("input[name='id']")!=undefined?$("input[name='id']").val():0;
		var jsonStr=$("input[name='field29']").val();
		
		if(gid>0)
			updateRediredUris($("input[name='enable_custom_location_id']").is(":checked")?$("input[name='custom_location_id']").val():gid);

		if(jsonStr!=[] && jsonStr!=undefined && jsonStr!=null && jsonStr!=''){
			var options=JSON.parse(jsonStr);
			if(options!=null && options!=undefined){
				for(var i=0;i<options.length;i++){
					var ele=window.parent.addComponent(options[i],containerId);
					// $("."+ele).parent().parent().addClass("incident-dropdown-container-inner");
				}
				
				let otherEle = document.evaluate("//div/div/div[text()='Other']", document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
				if(otherEle) $(otherEle).parent().parent().addClass("ingore-it");
			}
		}
		$("#custom_location_id").keyup(function(){
			if($("input[name='enable_custom_location_id']").is(":checked"))
				updateRediredUris($("input[name='custom_location_id']").val());
		});

		$("input[name='enable_custom_location_id']").on('click',function(e){
			if($("input[name='enable_custom_location_id']").is(":checked"))
				updateRediredUris($("input[name='custom_location_id']").val());
			else {
				updateRediredUris(gid);
			}
		});

		$('.btn.submit-location-settings-form').on('click', onSaveLocationSettings);
		
		$('input[name="enable_path_variable"]').on('click', function(e){
			if(gid>0){
				updateRediredUris($("input[name='enable_custom_location_id']").is(":checked")?$("input[name='custom_location_id']").val():gid);
			}
		});

		$(".membership-container-inner").find('.input_start-date').each((i, el) => {
			$(el).datepicker({
				language: "en",
				dateFormat: "yyyy/mm/dd",
				timeFormat: "hh:ii aa",
				onSelect: (formattedDate, date, inst) => {
					$(el).trigger("change");
				}
			});
		});

		enableDisableSub();
		$('input[name="enableSub"]').on('click', function(e){
			enableDisableSub();
		});

		$('input[name="enable_oauth2"]').on('click', function(e){
			if($('input[name="enable_oauth2"]').is(":checked")){
				$(".oauth2-setup:not(.not-required)").prop("disabled",false);
				$(".oauth2-setup:not(.not-required)").addClass("required");
			}else{
				$(".oauth2-setup:not(.not-required)").attr("disabled",true);
				$(".oauth2-setup:not(.not-required)").removeClass("required");
				$(".oauth2-setup:not(.not-required)").removeClass("error");
			}
			$(".val-not-required").removeClass("required");
			$(".val-not-required").removeClass("error");
		});

		$("input[name='subAnnaulyOrMonthly']").on("click",function(e){
			if($(e.currentTarget).attr("id")=="sub-monthly"){
				$("[for='notificationBefore']").text($("[for='notificationBefore']").text().replaceAll("60","7"));
				$("#notificationBefore").val("7");
			}else{
				$("[for='notificationBefore']").text($("[for='notificationBefore']").text().replaceAll("7","60"));
				$("#notificationBefore").val("60");
			}
		});
	};

	function enableDisableSub(){
		if($('input[name="enableSub"]').is(":checked")){
			$(".sub-setup:not(.not-required)").prop("disabled",false);
			$(".sub-setup:not(.not-required)").addClass("required");
			
			$("input[name='subAnnaulyOrMonthly']").prop("disabled",false);
			$("input[name='subAnnaulyOrMonthly']").addClass("required");
		}else{
			$(".sub-setup:not(.not-required)").attr("disabled",true);
			$(".sub-setup:not(.not-required)").removeClass("required");
			$(".sub-setup:not(.not-required)").removeClass("error");

			$("input[name='subAnnaulyOrMonthly']").prop("disabled",true);
			$("input[name='subAnnaulyOrMonthly']").removeClass("required");
			$("input[name='subAnnaulyOrMonthly']").removeClass("error");
		}
	}

	function updateRediredUris(gid){
		var cond=$('input[name="enable_path_variable"]').is(":checked");
		var oauth2RedirectURIBackend=location.protocol + '//' + location.host+"/action/sso-login"+(cond?"/":"?enc=")+gid;
		var oauth2RedirectURIAndroid=location.protocol + '//' + location.host+"/action/sso-login"+(cond?"/":"?enc=")+gid;
		var oauth2RedirectURIIOS=location.protocol + '//' + location.host+"/action/sso-login"+(cond?"/":"?enc=")+gid;
		var oauth2RedirectURIWeb=location.protocol + '//' + location.host+"/action/sso-login"+(cond?"/":"?enc=")+gid;
		
		$("#redirect_uri_backend").val(oauth2RedirectURIBackend);
		$("#redirect_uri_android").val(oauth2RedirectURIAndroid);
		$("#redirect_uri_ios").val(oauth2RedirectURIIOS);
		$("#redirect_uri_web").val(oauth2RedirectURIWeb);
	};
	function onSaveLocationSettings({currentTarget}) {
		const form = $(currentTarget).closest('.location-form-content');
		formValidator.validateForm(form);
		if (!form.hasClass('has-error')) {
			// Initialize an array to store the JSON objects
			const locationId = ("input[name='id']")!=undefined?$("input[name='id']").val():0;

			var jsonObjects = {};
			// Loop through each input element
			$('.sub-setup').each(function (i,input) {
				if(input.name!="_token")
					jsonObjects[input.name]=input.getAttribute("type")=="checkbox"?$(input).is(":checked"):(input.type=="number"?parseInt(input.value):input.value);
			});
			jsonObjects["subAnnaulyOrMonthly"]=$("#sub-annually").is(":checked");
			const field24=JSON.stringify(jsonObjects);
			console.warn(field24);

			jsonObjects = {};
			// Loop through each input element
			$('.oauth2-setup').each(function (i,input) {
				if(input.name!="_token")
					jsonObjects[input.name]=input.getAttribute("type")=="checkbox"?$(input).is(":checked"):input.value;
			});
			
			jsonObjects["locationId"]=$("input[name='enable_custom_location_id']").is(":checked")?$("input[name='custom_location_id']").val():locationId;

			const field25=JSON.stringify(jsonObjects);

			const field18 = {
				permission: $('[name=permission]:checked').val(),
				fullAccess: $('[name=fullAccess]:checked').val(),
			}			
			const field31 =$('[name=field31]:checked').val();
			const field28 =$('[name=field28]:checked').val();
			const field21 =$('[name=field21]:checked').val();
			const field22 =$('[name=field22]:checked').val();
			const field23 =$('[name=field23]:checked').val();
			
			var responseOptionElements=$(".response-type-container-item>.add-modify-page-inner-item-ctn-location-item__text>.first");
			var responseOptions=[];
			if(responseOptionElements && responseOptionElements!=null && responseOptionElements!=undefined){
				responseOptionElements.map((i, el) => {
					responseOptions.push(String(el.innerHTML));
				});
			}
			
			const data = {
				id: form.find('[name="id"]').val(),
				field18: JSON.stringify(field18),
				field19: $('[name=field19]').is(':checked'),
				field24,
				field25,
				field28,
				field21,
				field22,
				field23,
				field29:JSON.stringify(responseOptions==[]?[]:responseOptions),
				field31,
				_token:$('.oauth2-setup-token').find("input").val() 
			};
			locationsUtils.createOrUpdateLocation(Object.keys(data), Object.values(data), (id) => {
				if (id != null) {
					form.find('[name="id"]').val(id);
					
					locationsUtils.showMessage(form, '_success');
					form.find('.add-location-info__client_hidden')
						.removeClass('add-location-info__client_hidden')
						.find('input')
						.val(id);
				} else {
					locationsUtils.showMessage(form, '_server');
				}
				locationsUtils.removeOverlay();
			});
		}
	}

	$(init);
})(jQuery);
